
import React, { useMemo } from 'react';


import { useAnnotationEvents, useStore } from '../../../../hooks';
import { isCanvasPanMode } from '../../../../utils/canvasInteractionMode';
import MemoizedAnnotation from './MemoizedAnnotation';

const AnnotationNodes = () => {
  const { annotations = {}, selectionsIds = [], editorPreferences = {} } =
    useStore();
  const panMode = isCanvasPanMode(editorPreferences);
  const annotationEvents = useAnnotationEvents();
  const selectedIds = useMemo(() => new Set(selectionsIds), [selectionsIds]);

  return useMemo(
    () =>
      Object.values(annotations)
        .filter((annotation) => annotation.visible !== false)
        .map((annotation) => (
        <MemoizedAnnotation
          key={annotation.id}
          annotation={annotation}
          annotationEvents={annotationEvents}
          draggable={
            !panMode && selectedIds.has(annotation.id) && !annotation.locked
          }
        />
      )),
    [annotations, annotationEvents, panMode, selectedIds],
  );
};

export default AnnotationNodes;
